import { Element } from '../../equipment/models/elements/element';
import { Equipment } from '../../equipment/models/equipment';
import { EquipmentElements } from '../../equipment/models/elements/equipmentElements';

abstract class CanvasMode {

	private _active: boolean = false;
	private _enabled: boolean = false;

	get active(): boolean {
		return this._active;
	}

	set active(value: boolean) {
		this._active = value;
	}

	get enabled(): boolean {
		return this._enabled;
	}

	set enabled(value: boolean) {
		this._enabled = value;
		if (!this.enabled) this.active = false;
	}

	get icon(): string {
		return '';
	}

	get tooltip(): string {
		return '';
	}

	protected constructor(active: boolean, enabled: boolean) {
		this.active = active;
		this.enabled = enabled;
	}

	public abstract check(equipment: Equipment): void;

	public toggle(): void {
		this.active = !this.active;
	};
}

export class CanvasFlipMode extends CanvasMode {

	get icon(): string {
		return this.active ? 'flipFront' : 'flipBack';
	}

	get tooltip(): string {
		return this.active ? 'COMMON.FLIP_FRONT' : 'COMMON.FLIP_BACK';
	}

	constructor(active: boolean, enabled: boolean) {
		super(active, enabled);
	}

	public check(equipment: Equipment): void {
		this.enabled = equipment.allElements.some((el: Element) => el.parent.is(EquipmentElements.CentralPillar));
	}
}